import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import YatungFormInput from '@Src/_basic/components/YatungFormInput';
import { Options } from '@Src/_basic/components/YatungSelect';
import { ErrorMessage, Field } from 'formik';
import YatungDynamicFormSelect from '@Src/_basic/components/YatungDynamicFormSelect';
import { InitialWeightUnitFormData, IntlUnitConversionsArrayPostData } from '@Src/_basic/object/WeightUnitManageType';

interface Props {
  index: number;
  avaliableOptions: Array<Options>;
  values: InitialWeightUnitFormData;
}
export default function BottomMappingData(props: Props) {
  const { index, avaliableOptions, values } = props;

  const [dymanicOptions, setDymanicOptions] = useState<Array<Options>>([]);

  const filterOptions = async () => {
    const intlUnit = values.intlUnits.map((value: IntlUnitConversionsArrayPostData) => {
      return value.intlUnitId;
    });

    const intlUnitFilter = avaliableOptions.filter((value: Options) => {
      return !intlUnit.includes(value.value);
    });
    setDymanicOptions(intlUnitFilter);
  };
  useEffect(() => {
    filterOptions();
  }, [values]);

  return (
    <Stack direction={'row'} spacing={6} alignItems={'center'} justifyContent={'space-between'} sx={{ my: 2 }}>
      <Stack direction={'column'}>
        <Field
          id="intlUnitId"
          name={`intlUnits.${index}.intlUnitId`}
          type="number"
          label=""
          defaultValue={0}
          variant="standard"
          component={YatungDynamicFormSelect}
          sx={{ width: '204px' }}
          options={dymanicOptions}
          totalOptions={avaliableOptions}
          required
        />
        <ErrorMessage
          name={`intlUnits.${index}.intlUnitId`}
          render={(msg) => (
            <Stack>
              <Typography sx={{ fontSize: 14, color: '#d32f2f' }}>{msg}</Typography>
            </Stack>
          )}
        />
      </Stack>
      <Stack direction={'column'}>
        <Field
          id="intlUnitValue"
          name={`intlUnits.${index}.intlUnitValue`}
          type="number"
          label=""
          component={YatungFormInput}
          sx={{ width: '90%' }}
          required
        />
        <ErrorMessage
          name={`intlUnits.${index}.intlUnitValue`}
          render={(msg) => (
            <Stack>
              <Typography sx={{ fontSize: 14, color: '#d32f2f' }}>{msg}</Typography>
            </Stack>
          )}
        />
      </Stack>
    </Stack>
  );
}
